import { commonConfig } from './common';

export const environment = {
    ...commonConfig,
    authContextId: '6065',
    envName: 'nightly',
    standalone: false,
    production: false,
    fmsBaseUrl: 'https://feature-management-service.nightly.savvasrealizedev.com/feature-management-service',
    rbsConfig: {
        clientId: 'lJEsPqfPnFZ0zdTlPBDptA1rfwL3GR6l',
        grant_type: 'custom_castgc',
        scope: 'rbs',
    },
    // end lst-auth library required properties
    baseUrl: 'https://stage-google-class.savvasrealizedev.com/google/class/standalone',
    classSyncUrl: 'https://class-sync-service.nightly.savvasrealizedev.com/graphql',
    classMappingUrl: 'https://stage-class-mapping-service.savvasrealizedev.com/graphql',
    accountLinkingButtonConfig: {
        remoteEntryUrl: 'https://stage.google-user-webapp.savvasrealizedev.com/google/user/remoteEntry.json',
        exposedModuleKey: './GoogleUserWebappElement',
        elementTagName: 'app-account-linking-button',
        remoteName: 'google-user-webapp',
    },
    accountLinkingButtonLegacyConfig: {
        remoteEntryUrl: 'https://stage.google-user-webapp.savvasrealizedev.com/accountLinkingRemoteEntry.js',
        remoteAppName: 'account_linking',
        exposedResource: 'AccountLinkingButtonModule',
        componentName: 'AccountLinkingButtonComponent',
        exposedModuleName: './AccountLinkingButtonModule',
    },
};
